import axios from 'axios';

// Base API configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Kundli / Birth Chart APIs
export const kundliAPI = {
  generateKundli: (birthDetails) => api.post('/kundli/generate', birthDetails),
  getKundli: (id) => api.get(`/kundli/${id}`),
  getKundliPdf: (id) => api.get(`/kundli/${id}/pdf`, { responseType: 'blob' }),
};

// Horoscope APIs
export const horoscopeAPI = {
  getDailyHoroscope: (sign) => api.get(`/horoscope/${sign}/daily`),
  getWeeklyHoroscope: (sign) => api.get(`/horoscope/${sign}/weekly`),
  getMonthlyHoroscope: (sign) => api.get(`/horoscope/${sign}/monthly`),
  getYearlyHoroscope: (sign) => api.get(`/horoscope/${sign}/yearly`),
};

// Astrologer APIs
export const astrologerAPI = {
  getAstrologers: (params) => api.get('/astrologers', { params }),
  getAstrologerById: (id) => api.get(`/astrologers/${id}`),
  getAstrologerReviews: (id) => api.get(`/astrologers/${id}/reviews`),
  bookConsultation: (data) => api.post('/booking', data),
};

// Match Making APIs
export const matchMakingAPI = {
  checkCompatibility: (details) => api.post('/match-making/compatibility', details),
  getMatchReport: (id) => api.get(`/match-making/${id}`),
};

// Blog APIs
export const blogAPI = {
  getPosts: (params) => api.get('/blog', { params }),
  getPostBySlug: (slug) => api.get(`/blog/${slug}`),
  getCategories: () => api.get('/blog/categories'),
};

// Contact APIs
export const contactAPI = {
  sendMessage: (data) => api.post('/contact', data),
  subscribeNewsletter: (email) => api.post('/newsletter/subscribe', { email }),
};

// User APIs
export const userAPI = {
  register: (userData) => api.post('/auth/register', userData),
  login: (credentials) => api.post('/auth/login', credentials),
  getProfile: () => api.get('/user/profile'),
  updateProfile: (data) => api.put('/user/profile', data),
  getSavedHoroscopes: () => api.get('/user/saved-horoscopes'),
};

// Panchang APIs
export const panchangAPI = {
  getToday: (location) => api.get('/panchang/today', { params: { location } }),
  getByDate: (date, location) => api.get('/panchang/date', { params: { date, location } }),
  getMuhurat: (date, type) => api.get('/panchang/muhurat', { params: { date, type } }),
};

export default api;
